const OUTCOMES = [
  { n: "01", title: "Read your own biology", body: "Explain, in precise terms, why muscle exists and what signals cause it to grow, maintain, or disappear." },
  { n: "02", title: "Separate evidence from narrative", body: "Distinguish empirically grounded claims from post-hoc adaptive stories — in this curriculum and everywhere else." },
  { n: "03", title: "Apply one reasoning model everywhere", body: "Use the Environment → Stress → Adaptation → Capability → Expansion chain to analyze any physical demand, at any scale." },
  { n: "04", title: "Act on countermeasures, not guesses", body: "Know exactly what intentional physical stress is required to counteract modern sedentary environments — and why." },
];

export function TMSOutcomes() {
  return (
    <section data-testid="tms-outcomes-section" className="bg-card border-y border-border py-20 md:py-28">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <p className="text-xs uppercase tracking-[0.3em] text-[#5e1420] mb-10">What You Will Be Able to Do</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12">
          {OUTCOMES.map((o) => (
            <div key={o.n} data-testid={`tms-outcome-${o.n}`} className="flex gap-6">
              <span className="font-meta text-3xl text-[#c9962c]/70 shrink-0">{o.n}</span>
              <div>
                <h3 className="text-lg font-subtitle mb-2">{o.title}</h3>
                <p className="text-textSecondary text-sm leading-[1.7]">{o.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
